<template>
  <div class="detected">
    <div class="modal__body detected__body">
      <div class="detected__title">
        {{ title }}
      </div>
      <div class="detected__text">
        {{ text }}
      </div>
      <div class="detected__divider" />
    </div>
    <div class="detected__footer">
      <button
        class="button button_secondary button_md detected__capitalized-button"
        @click="onClose"
      >
        Try again
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  MSG_NO_VOICE_DETECTED_TITLE,
  MSG_NO_VOICE_DETECTED_TEXT,
  STORE_SET_PASSED,
} from "@/constants";

export default {
  props: {
    options: { type: Object, required: true },
  },
  data() {
    return {
      title: MSG_NO_VOICE_DETECTED_TITLE,
      text: MSG_NO_VOICE_DETECTED_TEXT,
    };
  },
  methods: {
    ...mapActions([STORE_SET_PASSED]),
    async onClose() {
      this.options.deleteAction();
      await this[STORE_SET_PASSED]({ [this.options.route]: false });
      this.$router.push({ name: this.options.route });
      this.$emit("close");
    },
  },
};
</script>
